import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme,
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { getTechnologyById, updateTechnology, postTechnology, deleteTechnology } from '../../../../api/technology'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyText() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        description: {
            'es': "",
            'en': ""
        }
    }
}

export default function EditTechnologyPage() {
    const technologyId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [technology, setTechnology] = useState(getEmptyText())
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);


    useEffect(() => {
        if (!technologyId) {
            disableLoadingData();
            return // history.push('/technologies');
        }

        getTechnologyById(technologyId).then(res => {
            setTechnology(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get technology.' })
            history.push('/technologies')
        })
    }, [technologyId, disableLoadingData, history])

    function saveTechnology() {
        if (!technologyId) {
            postTechnology(technology)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Technology created successfully.",
                    });
                    history.push("/technologies");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the technology.",
                    });
                });
        } else {
            updateTechnology(technologyId, technology).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/technologies')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!technology[element])
                technology[element] = {}
            let newText = technology[element]
            newText[lang] = event.target.value
            setTechnology({ ...technology, [element]: newText })
        } else
            setTechnology({ ...technology, [element]: event.target.value })
    }

    const handleChangeEditor = (element, lang, value) => {
        if (lang) {
            if (value === ' ')
                return
            if (!technology[element])
                technology[element] = {}
            let newText = technology[element]
            newText[lang] = value
            setTechnology({ ...technology, [element]: newText })
        } else
            setTechnology({ ...technology, [element]: value })
    }


    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(technology.title && technology.title[lang]) || ''}
                    onChange={handleChange('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
                <Editor
                    body={(technology.description && technology.description[lang]) || ''}
                    setBody={new_body => handleChangeEditor('description', lang, new_body)}
                    className='max-height'
                    lang={lang}
                    placeholder={'Enter text content here...'}
                />
            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit technology'>
                </CardHeader>
                <CardBody>
                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/technologies')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveTechnology()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save technology
            </Button>

            {technologyId && (
                <>
                    <MuiThemeProvider theme={theme}>
                        <Button
                            onClick={() => setOpenConfirmDialog(true)}
                            variant="outlined"
                            color="secondary"
                            style={{ marginRight: "20px" }}
                        >
                            Delete technology
                        </Button>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "auto",
                            }}
                        ></div>
                    </MuiThemeProvider>

                    <ConfirmDialog
                        title={"Are you sure you want to delete this technology?"}
                        open={openConfirmDialog}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteTechnology(technologyId)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Technology deleted successfully.",
                                    });
                                    history.push("/technologies");
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the technology.",
                                    });
                                });
                        }}
                    />
                </>
            )}
        </>
    );
}